import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { groupedCountries } from './data/countries';
import Select from './Select';
import { isCountryOptionsGrouped, onCountryOptionFocus } from './utils/country-groups-announcement';
// custom option renderer
const labelStyles = css({
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1.2
});
const flagStyles = css({
  fontSize: '1.125rem',
  // emoji size
  marginInlineEnd: "var(--ds-space-100, 8px)"
});
const Opt = ({
  children,
  icon
}) => jsx("div", {
  css: labelStyles
}, jsx("span", {
  css: flagStyles
}, icon), children);

// return the country name; used for searching
const getOptionLabel = ({
  abbr,
  code,
  name
}) => `${name} (${abbr.toUpperCase()}) +${code}`;

// set the country's abbreviation for the option value, (also searchable)
const getOptionValue = opt => opt.abbr;

// the text node of the control
const controlLabel = opt => jsx(Opt, {
  icon: opt.icon
}, opt.abbr.toUpperCase());
// the text node for an option
const optionLabel = ({
  abbr,
  code,
  icon,
  name
}) => jsx(Opt, {
  icon: icon
}, getOptionLabel({
  abbr,
  code,
  name
}));

// switch formatters based on render context (menu | value)
const formatOptionLabel = (opt, {
  context
}) => context === 'value' ? controlLabel(opt) : optionLabel(opt);

// put it all together
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Country select__
 *
 * A country select {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
const CountrySelect = props => {
  const {
    ariaLiveMessages,
    options
  } = props;
  const countryOptions = options || groupedCountries;
  return jsx(Select, _extends({
    isClearable: false,
    formatOptionLabel: formatOptionLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isMulti: false,
    options: countryOptions,
    ariaLiveMessages: isCountryOptionsGrouped(countryOptions) ? {
      onFocus: data => onCountryOptionFocus(data, countryOptions),
      ...ariaLiveMessages
    } : {
      ...ariaLiveMessages
    }
  }, props));
};
export default CountrySelect;